// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LockUi_wrapper__D8KSU","wrapperAllowed":"LockUi_wrapperAllowed__Jr7aW","iconWrapper":"LockUi_iconWrapper__jeAmw","iconDesc":"LockUi_iconDesc__QjelA"};